<template>
  <div
    :class="`formulate-input-element formulate-input-element--${context.type} input-${size}`"
    :data-type="context.type"
  >
    <FormulateSlot name="prefix" :context="context">
      <component
        :is="context.slotComponents.prefix"
        v-if="context.slotComponents.prefix"
        :context="context"
      />
    </FormulateSlot>
    <b-input-group :size="size" :class="`${prepend !== '' ? 'mc-input-group-prepend justify-content-end' : 'mc-input-group-append'}`">
      <FormulateInput
        type="text"
        v-model="context.model"
        v-bind="context.attributes"
        @blur="context.blurHandler"
        :class="`col-10 p-0 float-end ${prepend !== '' ? 'ms-2' : ''}`"
      />
      <!-- Append slot -->
      <template #append>
        <div class="input-group-append" v-if="append !== ''">
          <span :class="`input-group-text mc-border__append ${context.validationErrors?.length > 0 ? 'mc-border__append__error' : ''}`">{{ append }}</span>
        </div>
      </template>
      <!-- Prepend slot -->
      <template #prepend>
        <div class="input-group-prepend" v-if="prepend !== ''">
          <span :class="`input-group-text mc-border__prepend ${context.validationErrors?.length > 0 ? 'mc-border__prepend__error' : ''}`">{{ prepend }}</span>
        </div>
      </template>
    </b-input-group>
    <FormulateSlot name="suffix" :context="context">
      <component
        :is="context.slotComponents.suffix"
        v-if="context.slotComponents.suffix"
        :context="context"
      />
    </FormulateSlot>
  </div>
</template>

<style lang="scss">
.input-group-append > .input-group-text {
  color: $gray-600;
}
span.input-group-text {
  padding-block: 8px;
  padding-block: 8px;
  margin-left: -1px;
}
span.input-group-text.mc-border__append {
  border-bottom-left-radius: 0px;
  border-top-left-radius: 0px;
}
span.input-group-text.mc-border__prepend {
  border-bottom-right-radius: 0px;
  border-top-right-radius: 0px;
}
span.input-group-text.mc-border__append__error {
  border-left-color: red;
}
span.input-group-text.mc-border__prepend__error {
  border-right-color: red;
}
.input-group {
  position: relative;
  display: flex;
}

.input-group-prepend,
.input-group-append {
  display: flex;
  align-items: center;
  position: absolute;
  top: 0;
}

.input-group-prepend {
  left: 0;
}

.input-group-append {
  right: 0;
}

.mc-input-group-prepend .formulate-input-element.formulate-input-element--text.input-md {
  margin-left: 11px;
}
</style>

<script>
export default {
  props: {
    context: {
      type: Object,
      required: true,
    },
    size: {
      type: String,
      default: 'md',
    },
    append: {
      type: String,
      default: '',
    },
    prepend: {
      type: String,
      default: '',
    },
  },
}
</script>
